/**
 * Normalizes the answer options of a wizard question.
 *
 * The backend delivers options in three shapes:
 *   - a plain string (legacy config);
 *   - { label, value } for a fixed answer list, where the label stays Dutch and
 *     the value is the English machine value sent back to the backend;
 *   - { label, term_id } for taxonomy-enriched options.
 *
 * @param {Array|undefined} options
 *   The raw options from the question definition.
 *
 * @return {Array<{label: string, value: *}>}
 *   The normalized options.
 */
export function normalizeOptions(options) {
  if (!Array.isArray(options)) {
    return [];
  }

  return options.map((option) => {
    if (typeof option === 'string') {
      return { label: option, value: option };
    }

    let value = option.label;
    if (option.term_id !== undefined) {
      value = option.term_id;
    } else if (option.value !== undefined) {
      value = option.value;
    }

    return { label: option.label || '', value };
  });
}

export default normalizeOptions;
